// Thin fetch wrapper. Throws on non-2xx; redirects to /login on 401.

export class ApiError extends Error {
  status: number;
  constructor(status: number, message: string) {
    super(message);
    this.name = "ApiError";
    this.status = status;
  }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const resp = await fetch(path, {
    credentials: "include",
    ...init,
    headers: {
      accept: "application/json",
      ...(init?.headers ?? {}),
    },
  });
  if (resp.status === 401) {
    // No session — bounce to login. SPA navigation would skip the API call
    // but a hard redirect ensures the React app reloads with no session state.
    window.location.href = "/login";
    throw new ApiError(401, "unauthorized");
  }
  if (!resp.ok) {
    let msg = resp.statusText;
    try {
      const body = await resp.json();
      if (body && typeof body === "object" && "error" in body) msg = String((body as { error: unknown }).error);
    } catch { /* ignore */ }
    throw new ApiError(resp.status, msg);
  }
  return (await resp.json()) as T;
}

export function fmtMoney(n: number, currency: string, maximumFractionDigits = 2): string {
  try {
    return new Intl.NumberFormat("en-US", { style: "currency", currency, maximumFractionDigits }).format(n);
  } catch {
    return n.toFixed(maximumFractionDigits) + " " + currency;
  }
}
export function fmtInt(n: number): string {
  return new Intl.NumberFormat("en-US").format(n);
}
export function fmtPct(n: number | null, digits = 2): string {
  if (n === null || !Number.isFinite(n)) return "—";
  return `${n.toFixed(digits)}%`;
}
export function fmtFloat(n: number | null, digits = 2): string {
  if (n === null || !Number.isFinite(n)) return "—";
  return n.toFixed(digits);
}
